import { createBrowserHistory, createMemoryHistory } from 'history'
import { AppHistory } from 'types/global'

import { useSelector } from 'domains/redux/store'

export { useSelector, useDispatch } from 'domains/redux/store'

const history =
  typeof window === 'undefined' ? createMemoryHistory() : createBrowserHistory()

if (typeof window !== 'undefined') {
  window.__HISTORY__ = history
}

export function getHistory() {
  return history as AppHistory
}

export const useHistory = () => {
  const canGoBack = useSelector((state) => state.application.canGoBack)
  return {
    ...(history as AppHistory),
    push(url: string, state = 'NOT_FIRST_ROUTE') {
      history?.push(url, state)
      window.scrollTo({ top: 0, behavior: 'instant' })
    },
    backOrPush(url: string, state = 'NOT_FIRST_ROUTE') {
      if (canGoBack) {
        history?.back()
      } else {
        history?.push(url, state)
      }
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  }
}
